"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkbookFromDatabaseButton = exports.CreateWorkbookFromTableButton = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
// Style copied from ExplorerStyles.ts
var ToolbarButtonWithPadding = {
    fontWeight: 'normal',
    marginTop: widgets_1.TabStyles.Spacing.MediumSpace,
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    height: widgets_1.TabStyles.Sizing.RowHeight + "px",
    lineHeight: widgets_1.TabStyles.Sizing.RowHeight + "px",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};
function createHandleNewWorkbookForTableAction(tableId, siteUrls) {
    return function () {
        var newWindow = window.open('', '_blank');
        if (newWindow) {
            newWindow.location.href = siteUrls.newWorkbookFromTable(tableId);
        }
    };
}
function createHandleNewWorkbookForDatabaseAction(databaseId, siteUrls) {
    return function () {
        var newWindow = window.open('', '_blank');
        if (newWindow) {
            newWindow.location.href = siteUrls.newWorkbookFromDatabase(databaseId);
        }
    };
}
function isRowEnabledForTableOrDatabase(connectionType, allowedClasses) {
    return connectionType ? allowedClasses.indexOf(connectionType) > -1 : false;
}
var CreateWorkbookFromTableButton = /** @class */ (function (_super) {
    __extends(CreateWorkbookFromTableButton, _super);
    function CreateWorkbookFromTableButton(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedCreateHandlerForNewWorkbookFromTableAction = reselect_1.defaultMemoize(createHandleNewWorkbookForTableAction);
        _this.state = {
            isEmbedded: false,
            isSupportedDatabaseClass: false
        };
        if (_this.props.table.__typename !== 'CustomSQLTable' && _this.props.table.database != null) {
            var databaseClass_1 = _this.props.table.database.connectionType;
            // This unhandled promise might be a bug – the lint error goes away if we pass a no-op function to the catch.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            _this.props.apiRequests.getAllowedClasses({ federatableOnly: 'false' }).then(function (r) {
                var isSupported = isRowEnabledForTableOrDatabase(databaseClass_1, r.allowedClasses);
                _this.setState({
                    isEmbedded: !!_this.props.table.isEmbedded,
                    isSupportedDatabaseClass: isSupported
                });
            }).catch(); // Leave the state as the default
        }
        return _this;
    }
    CreateWorkbookFromTableButton.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, disabled: this.state.isEmbedded || !this.state.isSupportedDatabaseClass, handleClick: this.memoizedCreateHandlerForNewWorkbookFromTableAction(this.props.table.id, this.props.siteUrls), testId: 'CreateWorkbookFromTableButton', title: !this.state.isSupportedDatabaseClass || this.state.isEmbedded ?
                    Localize_1.Messages.ConnectToUnsupportedRowWarningTextDefault() : undefined, style: ToolbarButtonWithPadding }, Localize_1.Messages.NewWorkbookButton())));
    };
    return CreateWorkbookFromTableButton;
}(React.PureComponent));
exports.CreateWorkbookFromTableButton = CreateWorkbookFromTableButton;
var CreateWorkbookFromDatabaseButton = /** @class */ (function (_super) {
    __extends(CreateWorkbookFromDatabaseButton, _super);
    function CreateWorkbookFromDatabaseButton(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedCreateHandlerForNewWorkbookFromDatabaseAction = reselect_1.defaultMemoize(createHandleNewWorkbookForDatabaseAction);
        _this.state = { isEmbedded: false, isSupportedDatabaseClass: false };
        // This unhandled promise might be a bug – the lint error goes away if we pass a no-op function to the catch.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        _this.props.apiRequests.getAllowedClasses({ federatableOnly: 'false' }).then(function (r) {
            var isSupported = isRowEnabledForTableOrDatabase(_this.props.database.connectionType, r.allowedClasses);
            _this.setState({
                isEmbedded: !!_this.props.database.isEmbedded,
                isSupportedDatabaseClass: isSupported
            });
        }).catch(); // Leave the state as the default
        return _this;
    }
    CreateWorkbookFromDatabaseButton.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, disabled: this.state.isEmbedded || !this.state.isSupportedDatabaseClass, handleClick: this.memoizedCreateHandlerForNewWorkbookFromDatabaseAction(this.props.database.id, this.props.siteUrls), testId: 'CreateWorkbookFromDatabaseButton', title: this.state.isEmbedded || !this.state.isSupportedDatabaseClass ?
                    Localize_1.Messages.ConnectToUnsupportedRowWarningTextDefault() : undefined, style: ToolbarButtonWithPadding }, Localize_1.Messages.NewWorkbookButton())));
    };
    return CreateWorkbookFromDatabaseButton;
}(React.PureComponent));
exports.CreateWorkbookFromDatabaseButton = CreateWorkbookFromDatabaseButton;
//# sourceMappingURL=CreateWorkbookFromCatalogButtons.js.map